import Pages from 'pages';
import { ExternalModal, Modal } from 'ui/partials';
import Copilot from 'utils/providers/Copilot';

function App() {
  return (
    <ExternalModal>
      <Modal>
        <Copilot>
          <Pages />
        </Copilot>
      </Modal>
    </ExternalModal>
  );
}

export default App;
